import { post } from './request'

/**
 * 企业出海法律 AI 顾问接口。
 *
 * 后端：ruoyi-api /zjs/mini/law/*
 *   meta    —— 页面初始化选项（规模/热门国家/热门行业）、思考提示时长、免责声明
 *   analyze —— 四要素（问题/国家或区域/行业/规模）解析与引导
 *   ask     —— SSE 流式回答
 *
 * 流式部分不能用 axios（无法读取增量），改用 fetch + ReadableStream。
 */

const STREAM_URL = '/api/zjs/mini/law/ask'

// 页面元数据
export function fetchLawMeta () {
  return post('zjs/mini/law/meta').then(res => res.data || {})
}

// 四要素解析（返回：slots / missing / ready / message / options / legal / rejectMessage）
export function analyzeLawInput (payload) {
  return post('zjs/mini/law/analyze', payload).then(res => res.data || {})
}

/**
 * 发起流式回答。
 *
 * @param {Object} payload  { sessionId, input, question, country, industry, scale }
 * @param {Object} handlers 事件回调：meta / thinking / guide / reject / notice / delta / done / error
 * @returns {{ done: Promise, abort: Function }}
 */
export function streamLawAnswer (payload, handlers = {}) {
  const controller = new AbortController()

  const done = (async () => {
    const res = await fetch(STREAM_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'text/event-stream'
      },
      body: JSON.stringify({ ...payload, _timespan: Date.now() }),
      signal: controller.signal
    })

    if (!res.ok) {
      throw new Error('服务响应异常（HTTP ' + res.status + '）')
    }
    if (!res.body || !res.body.getReader) {
      throw new Error('当前浏览器不支持流式输出，请升级浏览器后重试')
    }

    const reader = res.body.getReader()
    const decoder = new TextDecoder('utf-8')
    let buffer = ''

    // eslint-disable-next-line no-constant-condition
    while (true) {
      const { value, done: finished } = await reader.read()
      if (finished) break
      buffer += decoder.decode(value, { stream: true })

      let match = buffer.match(/\r?\n\r?\n/)
      while (match) {
        const frame = buffer.slice(0, match.index)
        buffer = buffer.slice(match.index + match[0].length)
        dispatch(frame, handlers)
        match = buffer.match(/\r?\n\r?\n/)
      }
    }
    if (buffer.trim()) dispatch(buffer, handlers)
  })()

  return { done, abort: () => controller.abort() }
}

// 解析一帧 SSE：event: xxx / data: {...}
function dispatch (frame, handlers) {
  const lines = frame.split(/\r?\n/)
  let event = 'message'
  let data = ''
  lines.forEach(line => {
    if (line.indexOf('event:') === 0) {
      event = line.slice(6).trim()
    } else if (line.indexOf('data:') === 0) {
      data += line.slice(5).trim()
    }
  })
  if (!data) return

  let parsed
  try {
    parsed = JSON.parse(data)
  } catch (e) {
    parsed = { text: data }
  }
  const fn = handlers[event]
  if (typeof fn === 'function') fn(parsed)
}
